<template>
  <v-expansion-panel>
      <template>
          <v-expansion-panel-header class="mt-2">
                Importación de Ventas

              <template v-slot:actions>
                    <v-btn class="mr-5" @click.native.stop="reload()" icon small>
                        <v-icon color="primary">mdi-reload</v-icon>
                    </v-btn>
                    <v-btn @click="$store.dispatch('deleteWindowByUuid',{uuid : win.uuid})" icon small>
                        <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
              </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
              <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
                  <v-tabs-slider color="red"></v-tabs-slider>
                  
                  <v-tab  href="#tab-5" v-if="$store.getters['rolesUser/getCustomRole'](218) && TipoPlan != 'Emprendedor' && TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE'">
                      Ingreso masivo de ventas
                      <v-icon>mdi-account-details</v-icon>
                  </v-tab>

                  <v-tab  href="#tab-6" v-if="$store.getters['rolesUser/getCustomRole'](218) && TipoPlan == 'Contabilidad'">
                      Historial de ventas importadas
                      <v-icon>mdi-history</v-icon>
                  </v-tab>

              </v-tabs>

              <v-tabs-items v-model="tab" touchless>

                  <v-tab-item value="tab-5">
                    <v-card flat>
                        <v-card-text class="pa-1">
                                  <SalesManagmentMassiveEntry :win="win" :key="key" />               
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                  <v-tab-item value="tab-6" v-if="$store.getters['rolesUser/getCustomRole'](218) && TipoPlan == 'Contabilidad'">
                    <v-card flat>
                        <v-card-text class="pa-1">
                                  <ImportedSalesHistory :win="win" :key="`history-${key}`" />
                        </v-card-text>
                    </v-card>
                </v-tab-item>

              </v-tabs-items>
          </v-expansion-panel-content>
      </template>
      
  </v-expansion-panel>
</template>

<script>
  
  //import {mapState} from 'vuex';
  import SalesManagmentMassiveEntry from '../partial/SalesManagmentMassiveEntry.vue'
  import ImportedSalesHistory from '../partial/ImportedSalesHistory.vue'
  export default {
      name: "Sales",
      components: {
        SalesManagmentMassiveEntry,
        ImportedSalesHistory,
      },
      props: ['win'],
      data() {
          return {
              panel: 0,
              tab: null,
              key: 0,
              
              
          }
      },
      computed:{
          /*...mapState('customerData', {
              tab: 'tab-1'
          }),*/
      },
      mounted() {
    this.TipoPlan = JSON.parse(localStorage.getItem('user')).TipoPlan;
  
  },
      methods: {
          reload() {
              this.key++;
              setTimeout(() => {
              window.scrollTo(0, this.$store.getters.getScrollTop)
              //alert(this.$store.getters.getScrollTop)
              },300);
          },
      },

  }
</script>

<style scoped>

</style>
